import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from "@angular/router";
import {
    fetchBanners,
    fetchBannersSuccess,
    fetchBannersFailure,
    fetchBanner,
    fetchBannerSuccess,
    fetchBannerFailure,
    fetchFilteredBanners,
    fetchFilteredBannersSuccess,
    fetchFilteredBannersFailure,
    addBanner,
    addBannerSuccess,
    addBannerFailure,
    updateBanner,
    updateBannerSuccess,
    updateBannerFailure,
    deleteBanner,
    deleteBannerSuccess,
    deleteBannerFailure,
} from './banner.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { BannerService, SharedService, PageService} from '@services/index';

@Injectable()
export class BannerEffects {
  loadBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBanners),
      mergeMap(action =>
        this.bannerService.getBanners(action.page, action.filterOptions).pipe(
          map(res => {
            return fetchBannersSuccess({ banner: res });
          }),
          catchError(error => {
            return of(fetchBannersFailure({ error }));
          })
        )
      )
    )
  );

  loadBanner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBanner),
      mergeMap(action =>
        this.bannerService.getBanner(action.id).pipe(
          map(res => {
            return fetchBannerSuccess({ banner: res });
          }),
          catchError(error => {
            return of(fetchBannerFailure({ error }));
          })
        )
      )
    )
  );

  loadFilteredBanners$ = createEffect(() =>
      this.actions$.pipe(
        ofType(fetchFilteredBanners),
        mergeMap(action =>
          this.bannerService.getBanners(action.page, action.filterOptions).pipe(
            map(res => {
              return fetchFilteredBannersSuccess({ banners: res });
            }),
            catchError(error => {
              return of(fetchFilteredBannersFailure({ error }));
            })
          )
        )
      )
    );

    addBanner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addBanner),
      mergeMap(action =>
        this.bannerService.insertBanner(action.banner).pipe(
          map(banner => {
            return addBannerSuccess({ banner });
          }),
          tap(res => {
            this.pageService.onNotificationToggle({ show: true, error: false, message: 'Promotion Tool Added Successfully!' });
            setTimeout(() => {
              this.router.navigate([`/promotions/promotion_tools/promotion_tool/${res.banner["id"]}`]); 
            }, 2000);
          }),
          catchError(error => {
            this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
            return of(addBannerFailure({ error }));
          })
        )
      )
    )
  );

  updateBanner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateBanner),
      mergeMap(action =>
        this.bannerService.renewBanner(action.banner).pipe(
          map(banner => {
            return updateBannerSuccess({ banner });
          }),
          tap(res => {
            this.pageService.onNotificationToggle({ show: true, error: false, message: 'Promotion Tool Updated Successfully!' });
            setTimeout(() => {
              this.router.navigate([`/promotions/promotion_tools/promotion_tool/${res.banner["id"]}`]);
            }, 2000);
          }),
          catchError(error => {
            this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
            return of(updateBannerFailure({ error }));
          })
        )
      )
    )
  );

  deleteBanner$ = createEffect(() =>
  this.actions$.pipe(
    ofType(deleteBanner),
    mergeMap(action =>
      this.bannerService.removeBanner(action.id).pipe(
        map(() => {
          return deleteBannerSuccess({ id: action.id });
        }),
        catchError(error => {
          this.sharedService.onLoaderToggle(false);
          return of(deleteBannerFailure({ error }));
        })
      )
    )
  )
);

  constructor(
    private actions$: Actions,
    private bannerService: BannerService,
    private sharedService: SharedService,
    private router: Router,
    private pageService: PageService,
  ) {}

}
